// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Lw0F","rootNoMargin":"styles_rootNoMargin__2754J"};